const YoutubeIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_81_459)">
        <path
          d="M15 0C6.7125 0 0 6.7125 0 15C0 23.2875 6.7125 30 15 30C23.2875 30 30 23.2875 30 15C30 6.7125 23.2875 0 15 0ZM20.55 21.1125C17.925 21.2875 12.075 21.2875 9.45 21.1125C6.6 20.9125 6.275 19.525 6.25 15C6.275 10.4625 6.6 9.075 9.45 8.8875C12.075 8.7125 17.925 8.7125 20.55 8.8875C23.4 9.0875 23.725 10.475 23.75 15C23.725 19.5375 23.4 20.925 20.55 21.1125ZM12.5 12.075L18.65 15L12.5 17.9375V12.0875V12.075Z"
          fill="#3C3C3B"
        />
      </g>
      <defs>
        <clipPath id="clip0_81_459">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default YoutubeIcon;
